import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "content" }

import ChatInputBar from "@/components/Dialogues/Chat/ChatInputBar.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChatCover',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"slogan\" data-v-3ff69bae><img src=\"" + _imports_0 + "\" class=\"icon\" alt=\"\" data-v-3ff69bae><div class=\"title\" data-v-3ff69bae>我是超时代AI DeepSeek大模型，很高兴见到您</div></div><div class=\"title\" data-v-3ff69bae>DeepSeek-R1 671B满血版</div><div class=\"title mb-10\" data-v-3ff69bae>API直连-永不卡顿-永不崩溃-极速响应</div>", 3)),
    _createVNode(ChatInputBar)
  ]))
}
}

})